import { AuthDevice } from '@aws-amplify/auth/src/types'
import { produce } from 'immer'
import {
  FORGET_COGNITO_DEVICE_FAILURE,
  FORGET_COGNITO_DEVICE_INIT,
  FORGET_COGNITO_DEVICE_SUCCESS,
  ForgetCognitoDeviceActions,
  GET_COGNITO_TRUSTED_DEVICES_FAILURE,
  GET_COGNITO_TRUSTED_DEVICES_INIT,
  GET_COGNITO_TRUSTED_DEVICES_SUCCESS,
  GetCognitoTrustedDevicesActions,
} from 'src/app/ManageTrustedDevices/redux/manageTrustedDevices.actions'

export interface ManageTrustedDevicesState {
  loading: boolean
  devices?: AuthDevice[]
  manageTrustedDevicesTopLevelError?: string
}

export const initialState: ManageTrustedDevicesState = {
  loading: false,
}

export type Actions =
  | GetCognitoTrustedDevicesActions
  | ForgetCognitoDeviceActions

const ManageTrustedDevicesReducer = (
  state = initialState,
  action: Actions,
): ManageTrustedDevicesState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case FORGET_COGNITO_DEVICE_INIT:
      case GET_COGNITO_TRUSTED_DEVICES_INIT: {
        draft.loading = true
        return draft
      }

      case GET_COGNITO_TRUSTED_DEVICES_SUCCESS: {
        draft.loading = false
        draft.devices = action.payload
        return draft
      }

      case FORGET_COGNITO_DEVICE_FAILURE:
      case GET_COGNITO_TRUSTED_DEVICES_FAILURE: {
        draft.loading = false
        draft.manageTrustedDevicesTopLevelError = action.payload
        return draft
      }

      case FORGET_COGNITO_DEVICE_SUCCESS: {
        draft.devices = draft.devices?.filter(
          (device) => device.id !== action.payload,
        )
        draft.loading = false
        return draft
      }
    }
  })
}

export default ManageTrustedDevicesReducer
